import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helpers";

const columns = [
  {
    field: "practice_name",
    headerName: "Practice Name",
    flex: 2,
    minWidth: 220,
  },
  {
    field: "provider_name",
    headerName: "Provider",
    flex: 1.5,
    minWidth: 180,
  },
  {
    field: "dictation_date",
    headerName: "Dictation Month",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "count",
    headerName: "Dictation Count",
    type: "number",
    flex: 0.7,
    minWidth: 110,
  },
];

const PracticeListTable = ({ summary, loading }) => {
  const rows = useMemo(
    () =>
      summary.map((item, index) => ({
        id: index,
        practice_name: item.practice_name,
        provider_name: `${item.first_name || ""} ${
          item.last_name || ""
        }`.trim(),
        dictation_date: item.dictation_date,
        count: item.count,
      })),
    [summary]
  );

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
        }}
        slots={{
          pagination: DataGridCustomPagination,
          toolbar: GridToolbar,
        }}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
      />
    </Box>
  );
};

export default PracticeListTable;
